export interface OhayoErrorCollectConfig {
  /**
   * 监听频率，默认：`500`
   */
  freq?: number;
  /**
   * 顶部偏移值，默认：`145`
   */
  offsetTop?: number;
}
